/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function CostEstimateSheetInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { itemsHeader = [], rows = [] } = values;

  // Add/Remove Columns (itemsHeader)
  const addItemHeader = () => {
    const newHeaders = [...itemsHeader, "...."];
    setFieldValue("itemsHeader", newHeaders);
    // Add new value 0 to all rows
    const newRows = rows.map(row => ({
      ...row,
      itemAmounts: [...row.itemAmounts, 0]
    }));
    setFieldValue("rows", newRows);
  };

  const removeItemHeader = (idx) => {
    if (itemsHeader.length <= 1) return;
    const newHeaders = itemsHeader.filter((_, i) => i !== idx);
    setFieldValue("itemsHeader", newHeaders);
    // Remove value at idx from all rows
    const newRows = rows.map(row => ({
      ...row,
      itemAmounts: row.itemAmounts.filter((_, i) => i !== idx)
    }));
    setFieldValue("rows", newRows);
  };

  const handleHeaderChange = (idx, val) => {
    const newHeaders = [...itemsHeader];
    newHeaders[idx] = val;
    setFieldValue("itemsHeader", newHeaders);
  };

  const handleChangeAmount = (rIdx, iIdx, val) => {
    const num = (v) => (v && v !== "" && !isNaN(v) ? parseFloat(v) : 0);
    const newRows = [...rows];
    newRows[rIdx].itemAmounts[iIdx] = val;

    // Auto calculate total for this row
    const total = newRows[rIdx].itemAmounts.reduce((acc, curr) => acc + num(curr), 0);
    newRows[rIdx].totalAmount = total;

    setFieldValue("rows", newRows);
  };

  const num = (v) => (v && v !== "" && !isNaN(v) ? parseFloat(v) : 0);
  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "15px" },
    th: { border: "1px solid #000", padding: "8px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f9f9f9" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "60%" }}>
          <div>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.unit} onChange={(e) => setFieldValue("unit", e.target.value)} /></div>
          <div>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.address} onChange={(e) => setFieldValue("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "40%" }}>
          <div style={{ fontWeight: "bold" }}>Mẫu số S37-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase" }}>THẺ TÍNH GIÁ THÀNH SẢN PHẨM, DỊCH VỤ</h2>
        <div style={{ marginTop: 10 }}>
          Tháng <input disabled={containView} style={s.inputDottedSmall} value={values.reportMonth} onChange={(e) => setFieldValue("reportMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "60px" }} value={values.reportYear} onChange={(e) => setFieldValue("reportYear", e.target.value)} />
        </div>
        <div style={{ marginTop: 10 }}>
          Tên sản phẩm, dịch vụ: <input disabled={containView} style={{ ...s.inputDotted, width: "300px", textAlign: "center" }} value={values.productName} onChange={(e) => setFieldValue("productName", e.target.value)} />
        </div>
      </div>

      {/* TABLE */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "250px" }} rowSpan={2}>Chỉ tiêu</th>
              <th style={{ ...s.th, width: "120px" }} rowSpan={2}>Tổng số tiền</th>
              <th style={s.th} colSpan={itemsHeader.length}>Chia ra theo khoản mục</th>
            </tr>
            <tr>
              {itemsHeader.map((header, idx) => (
                <th key={idx} style={{ ...s.th, width: "100px", position: "relative" }}>
                  <input
                    disabled={containView}
                    style={s.inputTableCenter}
                    value={header}
                    onChange={(e) => handleHeaderChange(idx, e.target.value)}
                  />
                  {!containView && itemsHeader.length > 1 && (
                    <button type="button" style={{ ...s.removeBtn, position: "absolute", top: -10, right: 0 }} onClick={() => removeItemHeader(idx)}>×</button>
                  )}
                </th>
              ))}
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>1</th>
              {itemsHeader.map((_, idx) => (
                <th key={idx} style={s.th}>{idx + 2}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(rows || []).map((row, rIdx) => (
              <tr key={rIdx}>
                <td style={{ ...s.td, padding: "0 8px" }}>
                  <input disabled={containView} style={s.inputTable} value={row.criteria} onChange={(e) => {
                    const newRows = [...rows];
                    newRows[rIdx].criteria = e.target.value;
                    setFieldValue("rows", newRows);
                  }} />
                </td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 8px", fontWeight: "bold" }}>
                  {fmt(row.totalAmount)}
                </td>
                {itemsHeader.map((_, iIdx) => (
                  <td key={iIdx} style={s.td}>
                    <input
                      disabled={containView}
                      type="number"
                      style={s.inputTableRight}
                      value={row.itemAmounts[iIdx]}
                      onChange={(e) => handleChangeAmount(rIdx, iIdx, e.target.value)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {!containView && (
          <SoftBox mt={2} display="flex" gap={2}>
            <SoftButton variant="outlined" color="dark" onClick={addItemHeader}>+ Thêm(Cột)</SoftButton>
            <SoftButton variant="outlined" color="info" onClick={() => {
              const newRows = [...rows, createRowDefault("", itemsHeader.length)];
              setFieldValue("rows", newRows);
            }}>+ Thêm chỉ tiêu (Dòng)</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <b style={{ textTransform: "none" }}>Người ghi sổ</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => setFieldValue("ledgerClerk", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <b style={{ textTransform: "none" }}>Kế toán trưởng</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => setFieldValue("chiefAccountant", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "13px", marginBottom: "5px" }}>Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => setFieldValue("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => setFieldValue("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => setFieldValue("signingYear", e.target.value)} /></div>
          <b style={{ textTransform: "none" }}>Người đại diện theo pháp luật</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => setFieldValue("legalRepresentative", e.target.value)} /></SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}

const createRowDefault = (criteria, itemsCount = 1) => ({
  criteria: criteria || "",
  totalAmount: 0,
  itemAmounts: Array(itemsCount).fill(0),
});
